import { render, staticRenderFns } from "./schema.vue?vue&type=template&id=31338e2a&scoped=true"
import script from "./schema.vue?vue&type=script&lang=js"
export * from "./schema.vue?vue&type=script&lang=js"
import style0 from "./schema.vue?vue&type=style&index=0&id=31338e2a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31338e2a",
  null
  
)

export default component.exports